import React from "react";
import { ISocieteDetails } from "../../../models/interfaces/ISociete";
//Styles:

interface IProps {
    MarqueResult: ISocieteDetails;
}



const MarqueBloc5: React.FC<IProps> = ({
  MarqueResult
}) => {
  return (
    <div className="mt-2 card pae-detail-pub-card ">
    <div className="col-sm-12 card-body pae-card-grey" style={{maxHeight: "50px" , textAlign: 'left'}}>
    <div className="row">
          <div className="col-12 pae-detail-label">
              <b>Adresse(s)</b> 
          </div>
      </div>
    </div>
    <div className="col-sm-12 card-body" style={{ padding: '15px' }}>
  {MarqueResult?.Adresses.map((adresse, index) => (
    <div className="row" key={index}>
      <div className="col-12pae-detail-label" style={{ textAlign: 'left' }}>
        <b>{adresse.Type}</b>
      </div>
      <div style={{ marginBottom: '5px', textAlign: 'left' }}>
        {adresse?.Intitule}
      </div>
      <div style={{ marginBottom: '5px', textAlign: 'left' }}>
        {adresse?.NumeroVoie} {adresse?.TypeVoie} {adresse?.LibelleVoie} {adresse?.Complement}
      </div>
      <div style={{ marginBottom: '5px', textAlign: 'left' }}>
        {adresse?.CodePostal} {adresse?.Ville}
      </div>
      <div style={{ marginBottom: '5px', textAlign: 'left' }}>
        {adresse?.Pays}
      </div>
      <div className="col-12" style={{ textAlign: 'left' }}>
        {adresse?.MoyensDeLiaison?.map((liaison, liaisonIndex) => {
          // Add https:// if the URL doesn't start with http:// or https://
          const url = liaison.Type.toLowerCase() === 'internet' && !/^https?:\/\//i.test(liaison.Valeur)
            ? `https://${liaison.Valeur}`
            : liaison.Valeur;

          return (
            <div key={liaisonIndex} style={{ marginBottom: '5px', textAlign: 'left' }}>
              {liaison?.Type} :{' '}
              {liaison.Type.toLowerCase() === 'internet' ? (
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {liaison.Valeur}
                </a>
              ) : (
                <>{liaison?.Valeur}</>
              )}
            </div>
          );
        })}
      </div>
    </div>
  ))}
</div>

    </div>
  );
};

export default MarqueBloc5;
